import { createAsyncAction } from 'typesafe-actions';
import { repositories } from 'api';
import * as types from './types';

export const fetchProductsSet = createAsyncAction(
    types.FETCH_PRODUCTS_SET_REQUEST,
    types.FETCH_PRODUCTS_SET_SUCCEEDED,
    types.FETCH_PRODUCTS_SET_FAILED,
)<string, repositories.SimpleProduct, Error>();
